import { z } from 'zod';
import {
  agentSendMessageAPISchema,
  agentConfirmMessageAPISchema,
  agentListConversationsAPISchema,
  agentGetTranscriptAPISchema,
  agentMediaUrlAPISchema,
  agentResumeRunAPISchema,
  agentAdminListConversationsAPISchema,
  agentAdminGetTranscriptAPISchema,
  agentAdminSendMessageAPISchema,
  agentAdminSendTemplateAPISchema,
  agentAdminPatchConversationAPISchema,
  agentAdminAddAiNoteAPISchema,
  agentAdminVoiceSummaryAPISchema,
  agentAdminTranslateMessageAPISchema,
  agentAdminGetConversationAPISchema,
  agentAdminThreadIdentityAPISchema,
  agentAdminThreadFilingAPISchema,
  agentAdminUpdateThreadIdentityAPISchema,
  agentAdminIssueThreadWaybillAPISchema,
  agentAdminEditThreadOrderAPISchema,
  agentAdminReadThreadDocumentsAPISchema,
  agentAdminSetThreadFleetClientAPISchema,
  agentWhatsAppInboundAPISchema,
  agentWhatsAppCloudInboundAPISchema,
  agentWhatsApp360dialogPartnerAPISchema,
  agentWhatsAppBulkSendAPISchema,
} from './api/agent.api';
import { messageSendAPISchema } from './api/message.api';
import {
  messageCampaignCreateAPISchema,
  messageCampaignGetAllAPISchema,
  messageCampaignGetOneAPISchema,
  messageCampaignStatsAPISchema,
} from './api/message-campaign.api';
import { targetingResolveAPISchema } from './api/targeting.api';
import {
  channelAccountAdminListAPISchema,
  channelAccountAdminUpdateAPISchema,
} from './api/channel-account.api';
import {
  createOrderAPISchema,
  createMultiOrderAPISchema,
  orderGetOneAPISchema,
  businessOrdersSchema,
  currentUserOrdersAPISchema,
  myOrdersAPISchema,
  orderUpdateAPISchema,
  orderLocationChangePreviewAPISchema,
  OrderWaybillAPISchema,
  orderWaybillHtmlPreviewAPISchema,
  carrierOrdersSchema,
  publishedOrdersSchema,
  orderBestMatchCarrierVehiclesAPISchema,
  ordersGetAllAdminAPISchema,
  ordersGetAllGroupedAdminAPISchema,
  ordersGetGroupOrdersAdminAPISchema,
  orderAdminBulkUpdateAPISchema,
  getCommonRoutesAPISchema,
  createOrderAPISchemaAdmin,
  createMultiOrderAPISchemaAdmin,
  orderExportAdminAPISchema,
  orderExportCustomerAPISchema,
  orderExportCarrierAPISchema,
  orderEscalateAPISchema,
  orderContractCounterAPISchema,
  orderContractCancelAPISchema,
  orderContractCompleteAPISchema,
  orderGetPublicAPISchema,
} from './api/order.api';
import {
  offerCreateAPISchema,
  offerPreviewBroadcastAPISchema,
  offerGetInboxAPISchema,
  offerGetOutboxAPISchema,
  offerGetOneAPISchema,
  offerGetOrderPreviewAPISchema,
  offerAcceptTargetAPISchema,
  offerCounterTargetAPISchema,
  offerDeclineTargetAPISchema,
  offerWithdrawTargetAPISchema,
  offerWithdrawAPISchema,
  offerLoadBoardSearchAPISchema,
} from './api/offer.api';
import {
  sendOTPSchema,
  signInSchema,
  signUpSchema,
  adminCreateOrgSchema,
  signOutSchema,
  changeUserLangSchema,
  switchOrgSchema,
  refreshTokenSchema,
  revokeSessionSchema,
} from './api/auth.api';
import {
  savedLocationGetAllSchemaAPI,
  savedLocationSearchSchemaAPI,
  savedLocationCreateAPISchema,
  savedLocationUpdateAPISchema,
  savedLocationGetOneSchemaAPI,
  savedLocationDeleteAPISchema,
  savedLocationResolveGoogleUrlSchemaAPI,
} from './api/saved-location.api';
import {
  contactGetAllSchemaAPI,
  contactCreateAPISchema,
  contactUpdateAPISchema,
  contactGetOneSchemaAPI,
  contactDeleteAPISchema,
  contactGetAllAdminAPISchema,
  contactCreateAdminAPISchema,
} from './api/contact.api';
import {
  analyticsLeadsAPISchema,
  leadGetAllAdminAPISchema,
  leadGetOneAPISchema,
  leadCreateAdminAPISchema,
  leadUpdateAPISchema,
  leadDeleteAPISchema,
  leadAddPersonAPISchema,
  leadUpdatePersonAPISchema,
  leadRemovePersonAPISchema,
  leadAddActionAPISchema,
  leadUpdateActionAPISchema,
  leadAssignAPISchema,
  leadConvertLinkAPISchema,
  leadPublicCreateAPISchema,
} from './api/lead.api';
import {
  ticketAddNoteAPISchema,
  ticketAssignAPISchema,
  ticketCountsAPISchema,
  ticketCreateAPISchema,
  ticketDeleteAPISchema,
  ticketGetAllAdminAPISchema,
  ticketGetOneAPISchema,
  ticketUpdateAPISchema,
} from './api/ticket.api';
import {
  clientGetAllSchemaAPI,
  clientCreateAPISchema,
  clientUpdateAPISchema,
  clientGetOneSchemaAPI,
  clientDeleteAPISchema,
  clientGetAllAdminAPISchema,
  clientCreateAdminAPISchema,
  clientLookupByLinkAPISchema,
} from './api/client.api';
import {
  connectionGetAllAPISchema,
  connectionGetOneAPISchema,
  connectionAcceptAPISchema,
  connectionBlockAPISchema,
} from './api/connection.api';
import {
  profileGetAllAPISchema,
  profileGetOneAPISchema,
  profileCreateAdminAPISchema,
  profileUpdateAdminAPISchema,
  profileDeleteAdminAPISchema,
  profileBulkImportAdminAPISchema,
  profileSuggestAPISchema,
} from './api/profile.api';
import { orgGetAllAPISchema, orgGetOneAPISchema, orgUpdateAPISchema } from './api/org.api';
import {
  orgProfileGetAPISchema,
  orgProfileUpdateAPISchema,
  orgProfileAdminGetAPISchema,
  orgProfileAdminUpdateAPISchema,
} from './api/org-profile.api';
import { entityDirectorySearchAPISchema } from './api/entity-directory.api';
import {
  locationSearchSchema,
  locationAutocompleteSchema,
  addressAPISchema,
  locationDistanceSchema,
  locationMultiDistanceAPISchema,
  locationMultiDestinationDistanceSchema,
} from './api/location.api';
import {
  CreatePaymentAPISchema,
  getPaymentStatusAPISchema,
  createPaymentWithBankTransferAPISchema,
} from './api/payment/payment.api';
import {
  invoiceGetOneAPISchema,
  invoiceOrdersAPISchema,
  invoiceGetAllAdminAPISchema,
  invoicePayAdminAPISchema,
  invoiceExportAdminAPISchema,
  invoiceUploadProofAdminAPISchema,
  invoiceUploadProofCarrierAPISchema,
  invoiceProofReviewAdminAPISchema,
  invoiceCloseAdminAPISchema,
  invoiceCaptureLegsAdminAPISchema,
  invoiceEligibleLegsAdminAPISchema,
  invoiceCaptureLegsCurrentUserAPISchema,
  invoiceEligibleLegsCurrentUserAPISchema,
  invoiceOriginalCopyStatusUpdateAPISchema,
  invoicePayAPISchema,
  calcMultiInvoicesAPISchema,
} from './api/payment/invoice.api';
import {
  transactionGetOneAPISchema,
  transactionGetCurrentUserAPISchema,
  transactionGetAllAdminAPISchema,
  transactionOrdersAPISchema,
  verifyPendingTransactionAPISchema,
} from './api/payment/transaction.api';
import {
  WalletCreateAPISchema,
  walletGetOneAdminAPISchema,
  walletGetAllAdminAPISchema,
} from './api/payment/wallet.api';
import {
  accountGetAllAdminAPISchema,
  accountGetOneAdminAPISchema,
  accountTransactionGetAllAdminAPISchema,
  accountGetCurrentUserAPISchema,
  accountGetOneCurrentUserAPISchema,
  accountGetByPairAPISchema,
  accountTransactionGetCurrentUserAPISchema,
  accountTransactionGetOneCurrentUserAPISchema,
} from './api/payment/account.api';
import { analyticsAppSummaryAPISchema, myAnalyticsOverviewSchema } from './api/analytics.api';
import { analyticsUsersAPISchema } from './api/user.api';
import {
  agreementGetOneAPISchema,
  agreementGetManyAPISchema,
  agreementCreateAPISchema,
  agreementUpdateAPISchema,
} from './api/agreement.api';
import {
  financingAcceptOfferAPISchema,
  financingAdminGetAllAPISchema,
  financingAdminGetOneAPISchema,
  financingAdminUpdateInvoiceAPISchema,
  financingAdminUpsertOfferAPISchema,
  financingApproveRepaymentAPISchema,
  financingCancelAPISchema,
  financingCreateApplicationAPISchema,
  financingGetApplicationsAPISchema,
  financingGetOfferLenderContactsAPISchema,
  financingGetPartnersAPISchema,
  financingLenderExpressInterestAPISchema,
  financingLenderMarkFundedAPISchema,
  financingLenderMarkRepaidAPISchema,
  financingLenderRejectRepaymentAPISchema,
  financingLenderSubmitOfferAPISchema,
  financingLenderViewAPISchema,
  financingMarkOutcomeAPISchema,
  financingPartnerExpressInterestAPISchema,
  financingPartnerGetAPISchema,
  financingPartnerSubmitOfferAPISchema,
  financingRejectRepaymentAPISchema,
  financingSendToLendersAPISchema,
  financingSubmitRepaymentReceiptAPISchema,
  financingUpdateTagsAPISchema,
  financingUploadInvoiceDocumentAPISchema,
} from './api/financing.api';
import {
  lenderCreateAdminAPISchema,
  lenderGetActiveAPISchema,
  lenderGetAllAdminAPISchema,
  lenderGetOneAdminAPISchema,
  lenderSetStatusAdminAPISchema,
  lenderUpdateAdminAPISchema,
} from './api/lender.api';
import {
  referralAnalyticsActivityAdminAPISchema,
  referralAnalyticsPeopleAdminAPISchema,
  referralAnalyticsTimelineAdminAPISchema,
  referralLeadGetAllAdminAPISchema,
  referralLinkCreateAdminAPISchema,
  referralLinkGetAllAdminAPISchema,
  referralLinkGetOneAdminAPISchema,
  referralLinkResolveAPISchema,
  referralLinkShareAdminAPISchema,
  referralLinkUpdateAdminAPISchema,
  referralPartnerCreateAdminAPISchema,
  referralPartnerGetAllAdminAPISchema,
  referralPartnerGetOneAdminAPISchema,
  referralPartnerSummaryAdminAPISchema,
  referralPartnerUpdateAdminAPISchema,
  referralRelinkLeadAdminAPISchema,
  referralRewardGetAllAdminAPISchema,
  referralRewardGetOneAdminAPISchema,
  referralRewardMarkPaidAdminAPISchema,
  referralRewardVoidAdminAPISchema,
  referralTrackingCreateAPISchema,
  referralTrackingGetAllAdminAPISchema,
  referralTrackingStatsAdminAPISchema,
} from './api/referral';
import {
  appApplyEarlyAccessAPISchema,
  appIssueWaybillBayanAPISchema,
  appLogistiInstallAPISchema,
  logistiSettingsAPISchema,
  orderWaybillBayanAPISchema,
} from './api/app.api';
import {
  regionCreateAPISchema,
  regionGetOneSchemaAPI,
  regionUpdateAPISchema,
  regionGetAPISchema,
  regionManyAPISchema,
  regionDetailsAPISchema,
  regionImportSaudiMasterAPISchema,
  regionSearchAPISchema,
  regionTranslateAPISchema,
} from './api/region.api';
import {
  routeGetOneAPISchema,
  routeGetAllAPISchema,
  routeCreateAPISchema,
  routeUpdateAPISchema,
  routeCreateMultiAPISchema,
  routeUpdateMultiAPISchema,
  routeDeleteAPISchema,
} from './api/route.api';
import {
  vehicleCreateAPISchema,
  vehicleUpdateAPISchema,
  vehicleGetManyAPISchema,
  vehicleGetAllAdminAPISchema,
  vehicleCreateAdminAPISchema,
} from './api/vehicle.api';
import {
  calculatePriceSchema,
  calculateMultiDistancePriceAPISchema,
  calculatePriceAPIv2Schema,
  calculatePriceMultiRoutesSchema,
} from './api/price.api';

import {
  adminSendOTPSchema,
  adminVerifyOTPSchema,
  adminSignOutSchema,
  adminChangeLangSchema,
  adminCreateUserSchema,
  adminGetAllUsersSchema,
  adminUpdateUserSchema,
  adminGetOneUserSchema,
  adminDeleteUserSchema,
  adminRefreshTokenSchema,
} from './api/admin-auth.api';
import { accountOpsRequestSchema } from './api/account-ops.api';
import {
  memberCreateAPISchema,
  memberUpdateAPISchema,
  memberUpdateCurrentAPISchema,
  memberDeleteAPISchema,
  memberDriversAPISchema,
  memberGetOneAPISchema,
  memberCreateAdminAPISchema,
  memberGetAllAdminAPISchema,
  memberGetOneAdminAPISchema,
  memberUsersAPISchema,
} from './api/members.api';
import { versionCheckAPISchema } from './api/version.api';
import { userGetManyAPISchema, userGetOneAPISchema, userUpdateAPISchema } from './api/user.api';
import { currentUserMetaUpdateAPISchema } from './api/current-user.api';
import { devResetAPISchema } from './api/dev-tools.api';
import {
  driverGetOneAPISchema,
  driverGetAllAdminAPISchema,
  driverUpdateAdminAPISchema,
  driverDeleteAPISchema,
  driverGetAllCarrierAPISchema,
} from './api/driver.api';
import {
  subscriptionGetMineAPISchema,
  subscriptionGetUsageAPISchema,
  subscriptionGetAdminAPISchema,
  subscriptionAdminGetAllAPISchema,
  subscriptionSubscribeAPISchema,
  subscriptionPayAPISchema,
  subscriptionChangePlanAPISchema,
  subscriptionChangeIntervalAPISchema,
  subscriptionChangeSeatsAPISchema,
  subscriptionAddAddonAPISchema,
  subscriptionRemoveAddonAPISchema,
  subscriptionCancelAPISchema,
  subscriptionAdminOverrideAPISchema,
  subscriptionAdminForceRenewAPISchema,
  subscriptionAdminGrantCreditsAPISchema,
  subscriptionAdminRevokeCreditsAPISchema,
  subscriptionAdminResetFreeCreditsAPISchema,
  subscriptionPaymentMethodCheckoutAPISchema,
  subscriptionPaymentMethodDeleteAPISchema,
} from './api/sales/subscription.api';
import {
  billingGetOneAPISchema,
  billingGetManyAPISchema,
  billingAdminGetAllAPISchema,
  billingAdminCancelAPISchema,
} from './api/sales/billing.api';
import {
  billingTransactionGetOneAPISchema,
  billingTransactionGetManyAPISchema,
  billingTransactionAdminRefundAPISchema,
  billingTransactionByGatewayPaymentIdAPISchema,
} from './api/sales/billing-transaction.api';
import { featuresGetMineAPISchema, featuresGetAdminAPISchema } from './api/sales/features.api';
import { moyasarWebhookAPISchema } from './api/sales/moyasar.api';

export enum MainRoutes {
  adminAuth = 'admin-auth',
  agent = 'agent',
  agreement = 'agreement',
  analytics = 'analytics',
  auth = 'auth',
  bayan = 'bayan',
  billing = 'billing',
  billingTransaction = 'billing-transaction',
  cashback = 'cashback',
  clientConfig = 'client-config',
  clients = 'clients',
  config = 'config',
  connection = 'connection',
  contacts = 'contacts',
  currentUser = 'current-user',
  devTools = 'dev-tools',
  driver = 'driver',
  entityDirectory = 'entity-directory',
  features = 'features',
  financing = 'financing',
  featureFlags = 'feature-flags',
  apps = 'apps',
  lead = 'lead',
  lender = 'lender',
  location = 'location',
  member = 'member',
  message = 'message',
  monday = 'monday',
  moyasar = 'moyasar',
  offer = 'offer',
  order = 'order',
  accountOps = 'account-ops',
  org = 'org',
  orgProfile = 'org/profile',
  profile = 'profile',
  payment = 'payment',
  price = 'price',
  referral = 'referral',
  region = 'region',
  route = 'route',
  savedLocations = 'saved-locations',
  subscription = 'subscription',
  targeting = 'targeting',
  ticket = 'ticket',
  triggers = 'triggers',
  user = 'user',
  vehicle = 'vehicle',
  version = 'version',
  zapier = 'zapier',
}

export type APIRoute = {
  /**
   * Here is a sub path.
   * Always comes in the third place
   *
   * base_url/main_path/ **sub_path**
   */
  subPath: string;
  /**
   * a sub path which include :id for dynamic routes
   * base_url/main_path/sub_path/ **:id**
   */
  subPathWithId: string;
  /**
   * the full path to the endpoint (https://etc.com/api/etc/...)
   */
  endpoint: (baseURL: string) => string;
  method: 'GET' | 'PATCH' | 'POST' | 'DELETE';
  /**
   * Here is the main path:
   * base_url/ **mainPath** /subPath
   */
  mainPath: MainRoutes;
  /**
   * Zod schema for request validation (optional - some endpoints may not have validation)
   * Used by both backend (for validation) and frontend SDKs (for form validation)
   */
  schema?: z.ZodSchema;
};

const createPathWithParam = (
  mainPath: APIRoute['mainPath'],
  method: APIRoute['method'],
  subPath: APIRoute['subPath'],
  param: string,
  schema?: z.ZodSchema,
): Readonly<APIRoute> => {
  const endpoint = (baseURL: string) => {
    return `${baseURL}/${mainPath}/${param}/${subPath}`;
  };
  const subPathWithId = `${subPath}/:id`;

  return { subPath, method, mainPath, endpoint, subPathWithId, schema };
};

/**
 *
 * @param mainPath the first path. Ex: base_url/*mainPath/subPath
 * @param method
 * @param subPath the nested path after main path. Ex base_url/mainPath/*subPath
 * @param schema Optional Zod schema for request validation (from corresponding controller endpoint)
 * @returns the full endpoint path of the requested API and other path helpers
 */
const createPath = (
  mainPath: APIRoute['mainPath'],
  method: APIRoute['method'],
  subPath: APIRoute['subPath'],
  schema?: z.ZodSchema,
): Readonly<APIRoute> => {
  const subPathWithId = `${subPath}/:id`;

  const endpoint = (baseURL: string) => {
    return `${baseURL}/${mainPath}/${subPath}`;
  };

  return { subPath, method, mainPath, endpoint, subPathWithId, schema };
};

export const API_ENDPOINTS = {
  agent: {
    mainPath: MainRoutes.agent,
    paths: {
      sendMessage: createPath(MainRoutes.agent, 'POST', 'messages', agentSendMessageAPISchema),
      confirmMessage: createPath(
        MainRoutes.agent,
        'POST',
        'messages/confirm',
        agentConfirmMessageAPISchema,
      ),
      // Conversation history — thread list, transcript, and SSE
      // re-attach for the persistent ChatGPT-like history UI.
      listConversations: createPath(
        MainRoutes.agent,
        'GET',
        'conversations',
        agentListConversationsAPISchema,
      ),
      getTranscript: createPath(
        MainRoutes.agent,
        'GET',
        'conversations/messages',
        agentGetTranscriptAPISchema,
      ),
      adminListConversations: createPath(
        MainRoutes.agent,
        'GET',
        'admin/conversations',
        agentAdminListConversationsAPISchema,
      ),
      adminGetTranscript: createPath(
        MainRoutes.agent,
        'GET',
        'admin/conversations/messages',
        agentAdminGetTranscriptAPISchema,
      ),
      adminGetConversation: createPath(
        MainRoutes.agent,
        'GET',
        'admin/conversations/one',
        agentAdminGetConversationAPISchema,
      ),
      // Human takeover — staff reply / take over / hand back. SuperAdmin.
      // See docs/ai/human-takeover.md.
      adminSendMessage: createPath(
        MainRoutes.agent,
        'POST',
        'admin/conversations/messages',
        agentAdminSendMessageAPISchema,
      ),
      adminSendTemplate: createPath(
        MainRoutes.agent,
        'POST',
        'admin/conversations/templates',
        agentAdminSendTemplateAPISchema,
      ),
      adminPatchConversation: createPath(
        MainRoutes.agent,
        'PATCH',
        'admin/conversations',
        agentAdminPatchConversationAPISchema,
      ),
      adminAddAiNote: createPath(
        MainRoutes.agent,
        'POST',
        'admin/conversations/notes',
        agentAdminAddAiNoteAPISchema,
      ),
      adminVoiceSummary: createPath(
        MainRoutes.agent,
        'POST',
        'admin/conversations/messages/voice-summary',
        agentAdminVoiceSummaryAPISchema,
      ),
      adminTranslateMessage: createPath(
        MainRoutes.agent,
        'POST',
        'admin/conversations/messages/translate',
        agentAdminTranslateMessageAPISchema,
      ),
      // Thread ops — identity on file + issue the وثيقة for this thread.
      adminThreadIdentity: createPath(
        MainRoutes.agent,
        'GET',
        'admin/conversations/identity',
        agentAdminThreadIdentityAPISchema,
      ),
      adminThreadFiling: createPath(
        MainRoutes.agent,
        'GET',
        'admin/conversations/filing',
        agentAdminThreadFilingAPISchema,
      ),
      adminUpdateThreadIdentity: createPath(
        MainRoutes.agent,
        'PATCH',
        'admin/conversations/identity',
        agentAdminUpdateThreadIdentityAPISchema,
      ),
      adminIssueThreadWaybill: createPath(
        MainRoutes.agent,
        'POST',
        'admin/conversations/issue-waybill',
        agentAdminIssueThreadWaybillAPISchema,
      ),
      adminEditThreadOrder: createPath(
        MainRoutes.agent,
        'PATCH',
        'admin/conversations/order',
        agentAdminEditThreadOrderAPISchema,
      ),
      adminReadThreadDocuments: createPath(
        MainRoutes.agent,
        'POST',
        'admin/conversations/read-documents',
        agentAdminReadThreadDocumentsAPISchema,
      ),
      adminSetThreadFleetClient: createPath(
        MainRoutes.agent,
        'PATCH',
        'admin/conversations/fleet-client',
        agentAdminSetThreadFleetClientAPISchema,
      ),
      // Channel accounts — the connected lines / inboxes. List + staff
      // labels (title, description). SuperAdmin.
      adminListChannelAccounts: createPath(
        MainRoutes.agent,
        'GET',
        'admin/channel-accounts',
        channelAccountAdminListAPISchema,
      ),
      adminUpdateChannelAccount: createPath(
        MainRoutes.agent,
        'PATCH',
        'admin/channel-accounts',
        channelAccountAdminUpdateAPISchema,
      ),
      // Private-storage media (voice clips) → short-lived signed URL.
      // Authorized against the owning conversation, and the access is
      // logged. See ADR-006.
      mediaUrl: createPath(MainRoutes.agent, 'GET', 'media/url', agentMediaUrlAPISchema),
      resumeRun: createPath(MainRoutes.agent, 'GET', 'runs/stream', agentResumeRunAPISchema),
      // Unused leftover path (Buraq inbound removed). Do not wire a
      // controller to this. Live inbound is `whatsapp360dialogInbound`.
      whatsappBuraqInbound: createPath(
        MainRoutes.agent,
        'POST',
        'whatsapp/buraq/inbound',
        agentWhatsAppInboundAPISchema,
      ),
      // 360dialog Cloud API → Hero. Meta envelope. Auth via
      // `@WhatsApp360dialog()` (`WHATSAPP_360DIALOG_WEBHOOK_SECRET`).
      // ACK 200 immediately; the agent turn runs in the background.
      whatsapp360dialogInbound: createPath(
        MainRoutes.agent,
        'POST',
        'whatsapp/360dialog/inbound',
        agentWhatsAppCloudInboundAPISchema,
      ),
      // 360dialog Partner / Hub events (Embedded Signup later). Stub:
      // log and 200. Do not occupy this path with anything else.
      whatsapp360dialogPartner: createPath(
        MainRoutes.agent,
        'POST',
        'whatsapp/360dialog/partner',
        agentWhatsApp360dialogPartnerAPISchema,
      ),
      // SuperAdmin bulk template send on the system WhatsApp line —
      // stamps each send on the recipient's conversation for memory.
      whatsappBulkSend: createPath(
        MainRoutes.agent,
        'POST',
        'whatsapp/bulk-send',
        agentWhatsAppBulkSendAPISchema,
      ),
      // Unused leftover path (Buraq CLOSE sweep removed).
      whatsappCloseStaleThreads: createPath(
        MainRoutes.agent,
        'POST',
        'whatsapp/close-stale-threads',
      ),
    },
  },
  adminAuth: {
    mainPath: MainRoutes.adminAuth,
    paths: {
      sendOtp: createPath(MainRoutes.adminAuth, 'POST', 'send-otp', adminSendOTPSchema),
      verifyOtp: createPath(MainRoutes.adminAuth, 'POST', 'verify-otp', adminVerifyOTPSchema),
      me: createPath(MainRoutes.adminAuth, 'GET', 'me'), // No validation in controller
      signOut: createPath(MainRoutes.adminAuth, 'POST', 'sign-out', adminSignOutSchema),
      changeLang: createPath(MainRoutes.adminAuth, 'POST', 'change-lang', adminChangeLangSchema),
      createUser: createPath(MainRoutes.adminAuth, 'POST', 'create-user', adminCreateUserSchema),
      getAllUsers: createPath(
        MainRoutes.adminAuth,
        'GET',
        'admin-all-users',
        adminGetAllUsersSchema,
      ),
      updateUser: createPath(MainRoutes.adminAuth, 'PATCH', 'update-user', adminUpdateUserSchema),
      getOneUser: createPath(MainRoutes.adminAuth, 'GET', 'get-one-user', adminGetOneUserSchema),
      deleteUser: createPath(MainRoutes.adminAuth, 'DELETE', 'delete-user', adminDeleteUserSchema),
      refresh: createPath(MainRoutes.adminAuth, 'POST', 'refresh', adminRefreshTokenSchema),
    },
  },
  order: {
    mainPath: MainRoutes.order,
    paths: {
      getOne: createPath(MainRoutes.order, 'GET', '', orderGetOneAPISchema),
      getPublic: createPath(MainRoutes.order, 'GET', 'public', orderGetPublicAPISchema),
      getWaybill: createPath(MainRoutes.order, 'GET', 'waybill', OrderWaybillAPISchema),
      generateWaybill: createPath(MainRoutes.order, 'POST', 'waybill', OrderWaybillAPISchema),
      getWaybillHtmlPreview: createPath(
        MainRoutes.order,
        'GET',
        'waybill/html-preview',
        orderWaybillHtmlPreviewAPISchema,
      ),
      generateWaybillHtml: createPath(
        MainRoutes.order,
        'POST',
        'waybill/html-generate',
        OrderWaybillAPISchema,
      ),
      businessOrders: createPath(MainRoutes.order, 'GET', 'business', businessOrdersSchema),
      currentUserOrders: createPath(
        MainRoutes.order,
        'GET',
        'current-user',
        currentUserOrdersAPISchema,
      ),
      myOrders: createPath(MainRoutes.order, 'GET', 'my-orders', myOrdersAPISchema),
      carrierOrders: createPath(MainRoutes.order, 'GET', 'carrier', carrierOrdersSchema),
      publishedOrders: createPath(MainRoutes.order, 'GET', 'published', publishedOrdersSchema),
      createOne: createPath(MainRoutes.order, 'POST', '', createOrderAPISchema),
      createMulti: createPath(MainRoutes.order, 'POST', 'multi', createMultiOrderAPISchema),
      updateOne: createPath(MainRoutes.order, 'PATCH', '', orderUpdateAPISchema),
      /**
       * Read-only despite being a POST: the candidate destinations are a
       * nested array, which does not survive a query string, and a GET
       * with a body is not reliably proxied.
       */
      locationChangePreview: createPath(
        MainRoutes.order,
        'POST',
        'location-change-preview',
        orderLocationChangePreviewAPISchema,
      ),
      sync: createPath(MainRoutes.order, 'POST', 'sync'), // No validation in controller
      carrierBestMatchVehicles: createPath(
        MainRoutes.order,
        'GET',
        'carrier-best-match-vehicles',
        orderBestMatchCarrierVehiclesAPISchema,
      ),
      activeDriverOrder: createPath(MainRoutes.order, 'GET', 'active-driver-order'), // No validation in controller

      // admin apis
      adminGetAll: createPath(MainRoutes.order, 'GET', 'admin-all', ordersGetAllAdminAPISchema),
      adminGetAllGrouped: createPath(
        MainRoutes.order,
        'GET',
        'admin-all-grouped',
        ordersGetAllGroupedAdminAPISchema,
      ),
      adminGetGroupOrders: createPath(
        MainRoutes.order,
        'GET',
        'admin-group-orders',
        ordersGetGroupOrdersAdminAPISchema,
      ),
      adminUpdateBulk: createPath(
        MainRoutes.order,
        'PATCH',
        'admin-bulk-update',
        orderAdminBulkUpdateAPISchema,
      ),
      adminCreateOne: createPath(MainRoutes.order, 'POST', 'admin', createOrderAPISchemaAdmin),
      adminCreateMulti: createPath(
        MainRoutes.order,
        'POST',
        'admin-multi',
        createMultiOrderAPISchemaAdmin,
      ),
      adminExport: createPath(MainRoutes.order, 'PATCH', 'admin-export', orderExportAdminAPISchema),
      customerExport: createPath(
        MainRoutes.order,
        'PATCH',
        'customer-export',
        orderExportCustomerAPISchema,
      ),
      carrierExport: createPath(
        MainRoutes.order,
        'PATCH',
        'carrier-export',
        orderExportCarrierAPISchema,
      ),
      // common routes
      getCommonRoutes: createPath(
        MainRoutes.order,
        'GET',
        'common-routes',
        getCommonRoutesAPISchema,
      ),
      // order-contract-offer extensions (Phase 2)
      escalate: createPath(MainRoutes.order, 'POST', 'escalate', orderEscalateAPISchema),
      contractCounter: createPath(
        MainRoutes.order,
        'POST',
        'contract/counter',
        orderContractCounterAPISchema,
      ),
      contractCancel: createPath(
        MainRoutes.order,
        'POST',
        'contract/cancel',
        orderContractCancelAPISchema,
      ),
      contractComplete: createPath(
        MainRoutes.order,
        'POST',
        'contract/complete',
        orderContractCompleteAPISchema,
      ),
    },
  },
  offer: {
    mainPath: MainRoutes.offer,
    paths: {
      create: createPath(MainRoutes.offer, 'POST', '', offerCreateAPISchema),
      previewBroadcast: createPath(
        MainRoutes.offer,
        'POST',
        'preview-broadcast',
        offerPreviewBroadcastAPISchema,
      ),
      inbox: createPath(MainRoutes.offer, 'GET', 'inbox', offerGetInboxAPISchema),
      outbox: createPath(MainRoutes.offer, 'GET', 'outbox', offerGetOutboxAPISchema),
      getOne: createPath(MainRoutes.offer, 'GET', '', offerGetOneAPISchema),
      orderPreview: createPath(
        MainRoutes.offer,
        'GET',
        'order-preview',
        offerGetOrderPreviewAPISchema,
      ),
      acceptTarget: createPath(
        MainRoutes.offer,
        'POST',
        'accept-target',
        offerAcceptTargetAPISchema,
      ),
      counterTarget: createPath(
        MainRoutes.offer,
        'POST',
        'counter-target',
        offerCounterTargetAPISchema,
      ),
      declineTarget: createPath(
        MainRoutes.offer,
        'POST',
        'decline-target',
        offerDeclineTargetAPISchema,
      ),
      withdrawTarget: createPath(
        MainRoutes.offer,
        'POST',
        'withdraw-target',
        offerWithdrawTargetAPISchema,
      ),
      withdraw: createPath(MainRoutes.offer, 'POST', 'withdraw', offerWithdrawAPISchema),
      loadBoard: createPath(MainRoutes.offer, 'GET', 'load-board', offerLoadBoardSearchAPISchema),
    },
  },
  auth: {
    mainPath: MainRoutes.auth,
    paths: {
      // Unified endpoints — single auth surface (relations-v2). See
      // `docs/relations-v2/08-user-identity.md`. The legacy
      // `signInCustomer` / `signUpCustomer` / `signInCarrier` /
      // `signUpCarrier` aliases were removed in Phase 6 of the
      // `Business` / `Carrier` collection retirement.
      signIn: createPath(MainRoutes.auth, 'POST', 'sign-in', signInSchema),
      signUp: createPath(MainRoutes.auth, 'POST', 'sign-up', signUpSchema),

      sendOTP: createPath(MainRoutes.auth, 'POST', 'send-otp', sendOTPSchema),
      signOut: createPath(MainRoutes.auth, 'POST', 'sign-out', signOutSchema),
      changeLang: createPath(MainRoutes.auth, 'POST', 'change-lang', changeUserLangSchema),
      deleteAccount: createPath(MainRoutes.auth, 'POST', 'delete-account'), // No validation in controller
      canUseApp: createPath(MainRoutes.auth, 'GET', 'can-use-app'), // No validation in controller
      switchOrg: createPath(MainRoutes.auth, 'POST', 'switch-org', switchOrgSchema),
      me: createPath(MainRoutes.auth, 'GET', 'me'),

      // Auth-v2 refresh + session management. See
      // `apps/backend/src/app/auth/README.md` for the rotating
      // refresh-session lifecycle.
      refresh: createPath(MainRoutes.auth, 'POST', 'refresh', refreshTokenSchema),
      logoutAll: createPath(MainRoutes.auth, 'POST', 'logout-all'),
      listSessions: createPath(MainRoutes.auth, 'GET', 'sessions'),
      revokeSession: createPath(MainRoutes.auth, 'POST', 'sessions/revoke', revokeSessionSchema),

      // ADMIN APIs — unified admin-create endpoint. The legacy
      // `adminCreateCustomer` / `adminCreateCarrier` aliases were
      // removed alongside `BusinessModule` / `CarrierModule`.
      adminCreateOrg: createPath(MainRoutes.auth, 'POST', 'admin-create-org', adminCreateOrgSchema),
    },
  },
  member: {
    mainPath: MainRoutes.member,
    paths: {
      getDrivers: createPath(MainRoutes.member, 'GET', 'drivers', memberDriversAPISchema),
      // users are all the non driver users
      getUsers: createPath(MainRoutes.member, 'GET', 'users', memberUsersAPISchema),
      getOne: createPath(MainRoutes.member, 'GET', 'one', memberGetOneAPISchema),
      getCount: createPath(MainRoutes.member, 'GET', 'count'), // No validation in controller
      getCurrentMember: createPath(MainRoutes.member, 'GET', 'current'), // No validation in controller
      createOne: createPath(MainRoutes.member, 'POST', '', memberCreateAPISchema),
      updateOne: createPath(MainRoutes.member, 'PATCH', '', memberUpdateAPISchema),
      deleteOne: createPath(MainRoutes.member, 'DELETE', '', memberDeleteAPISchema),
      updateCurrentMember: createPath(
        MainRoutes.member,
        'PATCH',
        'current',
        memberUpdateCurrentAPISchema,
      ),

      // ADMIN APIs
      adminCreateOne: createPath(
        MainRoutes.member,
        'POST',
        'admin-create-member',
        memberCreateAdminAPISchema,
      ),
      adminGetAllMembers: createPath(
        MainRoutes.member,
        'GET',
        'admin-all-members',
        memberGetAllAdminAPISchema,
      ),
      adminGetOneMemberById: createPath(
        MainRoutes.member,
        'GET',
        'admin-one-member-by-id',
        memberGetOneAdminAPISchema,
      ),
    },
  },
  // Targeting — "who": one reusable query for campaigns, the agent, bulk sends.
  // Preview only; nothing is sent. See docs/ai/human-takeover.md § 8.
  targeting: {
    mainPath: MainRoutes.targeting,
    paths: {
      resolve: createPath(MainRoutes.targeting, 'POST', 'resolve', targetingResolveAPISchema),
    },
  },
  message: {
    mainPath: MainRoutes.message,
    paths: {
      send: createPath(MainRoutes.message, 'POST', 'send', messageSendAPISchema),
      // Campaigns — target (POST /targeting/resolve previews it) + template
      // on its channels. SuperAdmin. See docs/ai/human-takeover.md § Campaigns.
      campaignTemplates: createPath(MainRoutes.message, 'GET', 'campaigns/templates'),
      campaignCreate: createPath(
        MainRoutes.message,
        'POST',
        'campaigns',
        messageCampaignCreateAPISchema,
      ),
      campaignGetAll: createPath(
        MainRoutes.message,
        'GET',
        'campaigns',
        messageCampaignGetAllAPISchema,
      ),
      campaignGetOne: createPath(
        MainRoutes.message,
        'GET',
        'campaigns/one',
        messageCampaignGetOneAPISchema,
      ),
      campaignStats: createPath(
        MainRoutes.message,
        'GET',
        'campaigns/stats',
        messageCampaignStatsAPISchema,
      ),
    },
  },
  user: {
    mainPath: MainRoutes.user,
    paths: {
      getOne: createPath(MainRoutes.user, 'GET', '', userGetOneAPISchema),
      getMany: createPath(MainRoutes.user, 'GET', 'many', userGetManyAPISchema),
      createOne: createPath(MainRoutes.user, 'POST', ''), // No validation in controller
      updateOne: createPath(MainRoutes.user, 'PATCH', '', userUpdateAPISchema),
      missingInfo: createPath(MainRoutes.user, 'GET', 'missing-info'), // No validation in controller
    },
  },
  /**
   * `current-user/*` — endpoints that always operate on the
   * authenticated user's own row (never accept a `userId` arg).
   * See `docs/ai/user-signals.md` for the `meta` read/write model.
   */
  currentUser: {
    mainPath: MainRoutes.currentUser,
    paths: {
      /** Read the caller's `User` with `meta` populated. */
      getMeta: createPath(MainRoutes.currentUser, 'GET', 'meta'),
      /**
       * Partial write into the caller's `User.meta`. Every section
       * is orthogonal — clients send only what changed. See
       * `currentUserMetaUpdateAPISchema` for the payload shape.
       */
      updateMeta: createPath(
        MainRoutes.currentUser,
        'PATCH',
        'meta',
        currentUserMetaUpdateAPISchema,
      ),
    },
  },
  location: {
    mainPath: MainRoutes.location,
    paths: {
      address: createPath(MainRoutes.location, 'GET', 'address', addressAPISchema),
      distance: createPath(MainRoutes.location, 'POST', 'distance', locationDistanceSchema),
      multiDistance: createPath(
        MainRoutes.location,
        'POST',
        'multi-distance',
        locationMultiDistanceAPISchema,
      ),
      multiDestinationDistance: createPath(
        MainRoutes.location,
        'POST',
        'multi-destination-distance',
        locationMultiDestinationDistanceSchema,
      ),
      search: createPath(MainRoutes.location, 'POST', 'search', locationSearchSchema),
      autocomplete: createPath(
        MainRoutes.location,
        'POST',
        'autocomplete',
        locationAutocompleteSchema,
      ),
      currentUserLocationTracking: createPath(
        MainRoutes.location,
        'PATCH',
        'current-user-tracking',
      ),
    },
  },
  vehicle: {
    mainPath: MainRoutes.vehicle,
    paths: {
      getOne: createPath(MainRoutes.vehicle, 'GET', ''), // No validation in controller
      getMyVehicle: createPath(MainRoutes.vehicle, 'GET', 'me'), // No validation in controller
      getMany: createPath(MainRoutes.vehicle, 'GET', 'many', vehicleGetManyAPISchema),
      adminGetAll: createPath(MainRoutes.vehicle, 'GET', 'admin-all', vehicleGetAllAdminAPISchema),
      updateOne: createPath(MainRoutes.vehicle, 'PATCH', '', vehicleUpdateAPISchema),
      createOne: createPath(MainRoutes.vehicle, 'POST', '', vehicleCreateAPISchema),
      adminCreateOne: createPath(
        MainRoutes.vehicle,
        'POST',
        'admin-create-vehicle',
        vehicleCreateAdminAPISchema,
      ),
    },
  },
  monday: {
    mainPath: MainRoutes.monday,
    paths: {
      syncFields: createPath(MainRoutes.monday, 'GET', 'fields/sync'),
      orderSyncStatus: createPath(MainRoutes.monday, 'POST', 'order/sync/status'),
      orderSync: createPath(MainRoutes.monday, 'POST', 'order/sync'),
    },
  },
  triggers: {
    mainPath: MainRoutes.triggers,
    paths: {
      order: createPath(MainRoutes.triggers, 'POST', 'db/order'),
      business: createPath(MainRoutes.triggers, 'POST', 'db/business'),
      carrier: createPath(MainRoutes.triggers, 'POST', 'db/carrier'),
      user: createPath(MainRoutes.triggers, 'POST', 'db/user'),
      org: createPath(MainRoutes.triggers, 'POST', 'db/org'),
    },
  },
  price: {
    mainPath: MainRoutes.price,
    paths: {
      calculatePrice: createPath(MainRoutes.price, 'POST', 'calculate', calculatePriceSchema),
      calculateMultiPrice: createPath(
        MainRoutes.price,
        'POST',
        'calculate-multi',
        calculateMultiDistancePriceAPISchema,
      ),
      calculatePriceV2: createPath(
        MainRoutes.price,
        'POST',
        'calculate-v2',
        calculatePriceAPIv2Schema,
      ),
      calculatePriceMultiRoutes: createPath(
        MainRoutes.price,
        'POST',
        'calculate-multi-routes',
        calculatePriceMultiRoutesSchema,
      ),
    },
  },
  region: {
    mainPath: MainRoutes.region,
    paths: {
      createRegion: createPath(MainRoutes.region, 'POST', '', regionCreateAPISchema),
      queryManyRegions: createPath(MainRoutes.region, 'POST', 'many', regionManyAPISchema),
      getRegionDetails: createPath(MainRoutes.region, 'POST', 'details', regionDetailsAPISchema),
      querySingleRegion: createPath(MainRoutes.region, 'POST', 'one', regionGetAPISchema),
      getOne: createPath(MainRoutes.region, 'GET', '', regionGetOneSchemaAPI),
      updateRegion: createPath(MainRoutes.region, 'PATCH', '', regionUpdateAPISchema),
      getAllCities: createPath(MainRoutes.region, 'GET', 'cities'), // No validation in controller
      // Super-admin Excel upload — see docs/regions/02-import-saudi-master.md.
      // FormData is validated in the controller via FileInterceptor + Zod on the body.
      importSaudiMaster: createPath(
        MainRoutes.region,
        'POST',
        'import/saudi-master',
        regionImportSaudiMasterAPISchema,
      ),
      // AI / NLU resolution. Public-readable. Used by dispatchers + LLM agents.
      search: createPath(MainRoutes.region, 'GET', 'search', regionSearchAPISchema),
      // Render-time language resolution. Public, batched, edge-cached.
      translate: createPath(MainRoutes.region, 'GET', 'translate', regionTranslateAPISchema),
    },
  },
  agreement: {
    mainPath: MainRoutes.agreement,
    paths: {
      getAgreement: createPath(MainRoutes.agreement, 'GET', '', agreementGetOneAPISchema),
      getManyAgreement: createPath(MainRoutes.agreement, 'GET', 'many', agreementGetManyAPISchema),
      createAgreement: createPath(MainRoutes.agreement, 'POST', '', agreementCreateAPISchema),
      updateAgreement: createPath(MainRoutes.agreement, 'PATCH', '', agreementUpdateAPISchema),
    },
  },
  /**
   * Embedded-financing v0 endpoints. Backed by
   * `apps/backend/src/app/financing/`. The two `lender/*` paths are
   * the only PUBLIC routes — guarded by `accessTokenHash` lookup
   * inside `FinancingService` rather than JWT.
   */
  financing: {
    mainPath: MainRoutes.financing,
    paths: {
      getPartners: createPath(
        MainRoutes.financing,
        'GET',
        'partners',
        financingGetPartnersAPISchema,
      ),
      uploadInvoiceDocument: createPath(
        MainRoutes.financing,
        'POST',
        'uploads/invoice-document',
        financingUploadInvoiceDocumentAPISchema,
      ),
      createApplication: createPath(
        MainRoutes.financing,
        'POST',
        'applications',
        financingCreateApplicationAPISchema,
      ),
      getApplications: createPath(
        MainRoutes.financing,
        'GET',
        'applications',
        financingGetApplicationsAPISchema,
      ),
      partnerGet: createPath(MainRoutes.financing, 'GET', 'partner', financingPartnerGetAPISchema),
      partnerExpressInterest: createPath(
        MainRoutes.financing,
        'POST',
        'partner/express-interest',
        financingPartnerExpressInterestAPISchema,
      ),
      partnerSubmitOffer: createPath(
        MainRoutes.financing,
        'POST',
        'partner/offer',
        financingPartnerSubmitOfferAPISchema,
      ),
      lenderView: createPath(
        MainRoutes.financing,
        'GET',
        'lender-view-application',
        financingLenderViewAPISchema,
      ),
      lenderExpressInterest: createPath(
        MainRoutes.financing,
        'POST',
        'lender-view-application/express-interest',
        financingLenderExpressInterestAPISchema,
      ),
      lenderSubmitOffer: createPath(
        MainRoutes.financing,
        'POST',
        'lender-view-application/offer',
        financingLenderSubmitOfferAPISchema,
      ),
      lenderMarkFunded: createPath(
        MainRoutes.financing,
        'POST',
        'lender-view-application/mark-funded',
        financingLenderMarkFundedAPISchema,
      ),
      lenderMarkRepaid: createPath(
        MainRoutes.financing,
        'POST',
        'lender-view-application/mark-repaid',
        financingLenderMarkRepaidAPISchema,
      ),
      lenderRejectRepayment: createPath(
        MainRoutes.financing,
        'POST',
        'lender-view-application/reject-repayment',
        financingLenderRejectRepaymentAPISchema,
      ),
      acceptOffer: createPath(
        MainRoutes.financing,
        'POST',
        'applications/accept-offer',
        financingAcceptOfferAPISchema,
      ),
      getOfferLenderContacts: createPath(
        MainRoutes.financing,
        'GET',
        'applications/offer-lender-contacts',
        financingGetOfferLenderContactsAPISchema,
      ),
      submitRepaymentReceipt: createPath(
        MainRoutes.financing,
        'POST',
        'applications/submit-repayment-receipt',
        financingSubmitRepaymentReceiptAPISchema,
      ),
      approveRepayment: createPath(
        MainRoutes.financing,
        'POST',
        'applications/approve-repayment',
        financingApproveRepaymentAPISchema,
      ),
      rejectRepayment: createPath(
        MainRoutes.financing,
        'POST',
        'applications/reject-repayment',
        financingRejectRepaymentAPISchema,
      ),
      updateTags: createPath(
        MainRoutes.financing,
        'PATCH',
        'applications/tags',
        financingUpdateTagsAPISchema,
      ),
      markOutcome: createPath(
        MainRoutes.financing,
        'POST',
        'applications/outcome',
        financingMarkOutcomeAPISchema,
      ),
      sendToLenders: createPath(
        MainRoutes.financing,
        'POST',
        'applications/send-to-lenders',
        financingSendToLendersAPISchema,
      ),
      adminCancel: createPath(
        MainRoutes.financing,
        'POST',
        'applications/cancel',
        financingCancelAPISchema,
      ),
      adminUpdateInvoice: createPath(
        MainRoutes.financing,
        'PATCH',
        'applications/invoice',
        financingAdminUpdateInvoiceAPISchema,
      ),
      adminUpsertOffer: createPath(
        MainRoutes.financing,
        'POST',
        'applications/admin/offer',
        financingAdminUpsertOfferAPISchema,
      ),
      adminGetAll: createPath(
        MainRoutes.financing,
        'GET',
        'admin/applications',
        financingAdminGetAllAPISchema,
      ),
      adminGetOne: createPath(
        MainRoutes.financing,
        'GET',
        'admin/applications/get-one',
        financingAdminGetOneAPISchema,
      ),
    },
  },
  /**
   * Lender directory endpoints. `getActive` is JWT-authed but
   * accessible to any role; the admin endpoints are gated by
   * `@SuperAdmin()` inside the controller. The lender's Mongo
   * `_id` is the canonical identifier exposed by every endpoint.
   */
  lender: {
    mainPath: MainRoutes.lender,
    paths: {
      getActive: createPath(MainRoutes.lender, 'GET', 'active', lenderGetActiveAPISchema),
      adminGetAll: createPath(MainRoutes.lender, 'GET', 'admin-all', lenderGetAllAdminAPISchema),
      adminGetOne: createPath(MainRoutes.lender, 'GET', 'admin-one', lenderGetOneAdminAPISchema),
      adminCreate: createPath(
        MainRoutes.lender,
        'POST',
        'admin-create',
        lenderCreateAdminAPISchema,
      ),
      adminUpdate: createPath(
        MainRoutes.lender,
        'PATCH',
        'admin-update',
        lenderUpdateAdminAPISchema,
      ),
      adminStatus: createPath(
        MainRoutes.lender,
        'PATCH',
        'admin-status',
        lenderSetStatusAdminAPISchema,
      ),
    },
  },
  /**
   * Referral program — partners, their links / codes, deduped tracking
   * hits and the reward ledger. Backend module:
   * `apps/backend/src/app/referral/`. Two endpoints are public
   * (`link/resolve`, `tracking`); everything else is `@SuperAdmin()`.
   * See `docs/referral.md`.
   */
  referral: {
    mainPath: MainRoutes.referral,
    paths: {
      // ── public ──
      linkResolve: createPath(
        MainRoutes.referral,
        'GET',
        'link/resolve',
        referralLinkResolveAPISchema,
      ),
      trackingCreate: createPath(
        MainRoutes.referral,
        'POST',
        'tracking',
        referralTrackingCreateAPISchema,
      ),
      /**
       * The `hero-r.js` embed served from the API origin, so an external
       * site (Wathiqa Plus) needs one host for both the script and the
       * hits it posts. Plain JavaScript response, no schema.
       */
      script: createPath(MainRoutes.referral, 'GET', 'hero-r.js'),

      // ── partners (admin) ──
      partnerAdminGetAll: createPath(
        MainRoutes.referral,
        'GET',
        'partner/admin-all',
        referralPartnerGetAllAdminAPISchema,
      ),
      partnerAdminGetOne: createPath(
        MainRoutes.referral,
        'GET',
        'partner/admin-one',
        referralPartnerGetOneAdminAPISchema,
      ),
      partnerAdminSummary: createPath(
        MainRoutes.referral,
        'GET',
        'partner/admin-summary',
        referralPartnerSummaryAdminAPISchema,
      ),
      partnerAdminCreate: createPath(
        MainRoutes.referral,
        'POST',
        'partner/admin-create',
        referralPartnerCreateAdminAPISchema,
      ),
      partnerAdminUpdate: createPath(
        MainRoutes.referral,
        'PATCH',
        'partner/admin-update',
        referralPartnerUpdateAdminAPISchema,
      ),

      // ── links (admin) ──
      linkAdminGetAll: createPath(
        MainRoutes.referral,
        'GET',
        'link/admin-all',
        referralLinkGetAllAdminAPISchema,
      ),
      linkAdminGetOne: createPath(
        MainRoutes.referral,
        'GET',
        'link/admin-one',
        referralLinkGetOneAdminAPISchema,
      ),
      linkAdminShare: createPath(
        MainRoutes.referral,
        'GET',
        'link/admin-share',
        referralLinkShareAdminAPISchema,
      ),
      linkAdminCreate: createPath(
        MainRoutes.referral,
        'POST',
        'link/admin-create',
        referralLinkCreateAdminAPISchema,
      ),
      linkAdminUpdate: createPath(
        MainRoutes.referral,
        'PATCH',
        'link/admin-update',
        referralLinkUpdateAdminAPISchema,
      ),

      // ── leads (admin) ──
      leadAdminGetAll: createPath(
        MainRoutes.referral,
        'GET',
        'lead/admin-all',
        referralLeadGetAllAdminAPISchema,
      ),
      // ── tracking (admin) ──
      trackingAdminGetAll: createPath(
        MainRoutes.referral,
        'GET',
        'tracking/admin-all',
        referralTrackingGetAllAdminAPISchema,
      ),
      trackingAdminStats: createPath(
        MainRoutes.referral,
        'GET',
        'tracking/admin-stats',
        referralTrackingStatsAdminAPISchema,
      ),
      analyticsAdminActivity: createPath(
        MainRoutes.referral,
        'GET',
        'analytics/admin-activity',
        referralAnalyticsActivityAdminAPISchema,
      ),
      analyticsAdminPeople: createPath(
        MainRoutes.referral,
        'GET',
        'analytics/admin-people',
        referralAnalyticsPeopleAdminAPISchema,
      ),
      analyticsAdminTimeline: createPath(
        MainRoutes.referral,
        'GET',
        'analytics/admin-timeline',
        referralAnalyticsTimelineAdminAPISchema,
      ),

      // ── rewards (admin) ──
      rewardAdminGetAll: createPath(
        MainRoutes.referral,
        'GET',
        'reward/admin-all',
        referralRewardGetAllAdminAPISchema,
      ),
      rewardAdminGetOne: createPath(
        MainRoutes.referral,
        'GET',
        'reward/admin-one',
        referralRewardGetOneAdminAPISchema,
      ),
      rewardAdminMarkPaid: createPath(
        MainRoutes.referral,
        'POST',
        'reward/admin-mark-paid',
        referralRewardMarkPaidAdminAPISchema,
      ),
      rewardAdminVoid: createPath(
        MainRoutes.referral,
        'POST',
        'reward/admin-void',
        referralRewardVoidAdminAPISchema,
      ),
      relinkLeadAdmin: createPath(
        MainRoutes.referral,
        'POST',
        'reward/admin-relink-lead',
        referralRelinkLeadAdminAPISchema,
      ),
    },
  },
  route: {
    mainPath: MainRoutes.route,
    paths: {
      getOne: createPath(MainRoutes.route, 'GET', '', routeGetOneAPISchema),
      getAll: createPath(MainRoutes.route, 'GET', 'all', routeGetAllAPISchema),
      createOne: createPath(MainRoutes.route, 'POST', '', routeCreateAPISchema),
      createMulti: createPath(MainRoutes.route, 'POST', 'multi', routeCreateMultiAPISchema),
      updateOne: createPath(MainRoutes.route, 'PATCH', '', routeUpdateAPISchema),
      updateMulti: createPath(MainRoutes.route, 'PATCH', 'multi', routeUpdateMultiAPISchema),
      deleteOne: createPath(MainRoutes.route, 'DELETE', '', routeDeleteAPISchema),
    },
  },
  clientConfig: {
    mainPath: MainRoutes.clientConfig,
    paths: {
      me: createPath(MainRoutes.clientConfig, 'GET', 'me'),
    },
  },
  config: {
    mainPath: MainRoutes.config,
    paths: {
      getAppConfig: createPath(MainRoutes.config, 'GET', 'app'),
    },
  },
  driver: {
    mainPath: MainRoutes.driver,
    paths: {
      getOne: createPath(MainRoutes.driver, 'GET', '', driverGetOneAPISchema),
      getCarrierDrivers: createPath(
        MainRoutes.driver,
        'GET',
        'carrier-drivers',
        driverGetAllCarrierAPISchema,
      ),

      // admin apis
      adminGetAll: createPath(MainRoutes.driver, 'GET', 'admin-all', driverGetAllAdminAPISchema),
      adminUpdate: createPath(
        MainRoutes.driver,
        'PATCH',
        'admin-update',
        driverUpdateAdminAPISchema,
      ),
      adminDelete: createPath(MainRoutes.driver, 'DELETE', 'admin-delete', driverDeleteAPISchema),
    },
  },
  payment: {
    mainPath: MainRoutes.payment,
    paths: {
      getOneTransaction: createPath(
        MainRoutes.payment,
        'GET',
        'transaction',
        transactionGetOneAPISchema,
      ),
      getOneInvoice: createPath(MainRoutes.payment, 'GET', 'invoice', invoiceGetOneAPISchema),
      createOne: createPath(MainRoutes.payment, 'POST', 'checkout', CreatePaymentAPISchema),
      createOneBankTransfer: createPath(
        MainRoutes.payment,
        'POST',
        'bank-transfer',
        createPaymentWithBankTransferAPISchema,
      ),
      processApplePayPayment: createPath(MainRoutes.payment, 'POST', 'apple-pay'), // No validation in controller
      checkPayment: createPathWithParam(
        MainRoutes.payment,
        'GET',
        'status',
        ':checkoutId',
        getPaymentStatusAPISchema,
      ),
      updateOne: createPath(MainRoutes.payment, 'PATCH', ''), // No validation in controller
      createWallet: createPath(MainRoutes.payment, 'POST', 'wallet', WalletCreateAPISchema),
      // user endpoints
      getUserInvoices: createPath(MainRoutes.payment, 'GET', 'user/invoices'), // No validation in controller
      getUserTransactions: createPath(
        MainRoutes.payment,
        'GET',
        'user/transactions',
        transactionGetCurrentUserAPISchema,
      ),
      getUserBalance: createPath(MainRoutes.payment, 'GET', 'user/balance'), // No validation in controller
      getInvoiceOrders: createPath(
        MainRoutes.payment,
        'GET',
        'user/invoice-orders',
        invoiceOrdersAPISchema,
      ),

      // Party-facing bilateral Account endpoints. The controller
      // resolves the viewer from the auth token and AND-s a
      // "viewer must be on parties[]" guard onto every query.
      getCurrentUserAccounts: createPath(
        MainRoutes.payment,
        'GET',
        'accounts',
        accountGetCurrentUserAPISchema,
      ),
      getCurrentUserAccount: createPath(
        MainRoutes.payment,
        'GET',
        'account',
        accountGetOneCurrentUserAPISchema,
      ),
      getCurrentUserAccountByPair: createPath(
        MainRoutes.payment,
        'GET',
        'account/by-pair',
        accountGetByPairAPISchema,
      ),
      getCurrentUserAccountTransactions: createPath(
        MainRoutes.payment,
        'GET',
        'account-transactions',
        accountTransactionGetCurrentUserAPISchema,
      ),
      getCurrentUserAccountTransaction: createPath(
        MainRoutes.payment,
        'GET',
        'account-transaction',
        accountTransactionGetOneCurrentUserAPISchema,
      ),

      // Manual invoice creation — party-facing twin of
      // `adminEligibleLegs` / `adminCaptureLegs`. Seller-only on the
      // backend: the viewer's org is pinned as the seller, and the
      // capture loop refuses legs where the viewer is not the seller.
      getEligibleLegs: createPath(
        MainRoutes.payment,
        'GET',
        'invoices/eligible-legs',
        invoiceEligibleLegsCurrentUserAPISchema,
      ),
      captureLegs: createPath(
        MainRoutes.payment,
        'POST',
        'invoices/capture-legs',
        invoiceCaptureLegsCurrentUserAPISchema,
      ),
      updateInvoiceOriginalCopyStatus: createPath(
        MainRoutes.payment,
        'POST',
        'invoices/original-copy-status',
        invoiceOriginalCopyStatusUpdateAPISchema,
      ),
      /**
       * Party-facing "record a payment" endpoint. Role-neutral —
       * any party on `Invoice.partyIds` can record an off-platform
       * payment that closes (or partially closes) the invoice.
       */
      payInvoice: createPath(MainRoutes.payment, 'POST', 'invoices/pay', invoicePayAPISchema),
      getTransactionOrders: createPath(
        MainRoutes.payment,
        'GET',
        'user/transaction-orders',
        transactionOrdersAPISchema,
      ),
      hyperPayWebhook: createPath(MainRoutes.payment, 'POST', 'hyperpay-webhook'), // No validation in controller

      // Customer endpoints — invoice calculations
      calcInvoices: createPath(
        MainRoutes.payment,
        'GET',
        'calc-invoices',
        calcMultiInvoicesAPISchema,
      ),
      getAllUnpaidInvoices: createPath(MainRoutes.payment, 'GET', 'unpaid-invoices'),
      getUnpaidTotal: createPath(MainRoutes.payment, 'GET', 'unpaid-total'),

      // Carrier endpoints
      carrierUploadInvoiceProof: createPath(
        MainRoutes.payment,
        'POST',
        'carrier/invoice-proof',
        invoiceUploadProofCarrierAPISchema,
      ),

      // Admin endpoints
      adminGetAllTransactions: createPath(
        MainRoutes.payment,
        'GET',
        'admin/transactions',
        transactionGetAllAdminAPISchema,
      ),
      adminGetAllInvoices: createPath(
        MainRoutes.payment,
        'GET',
        'admin/invoices',
        invoiceGetAllAdminAPISchema,
      ),
      adminPayInvoice: createPath(
        MainRoutes.payment,
        'POST',
        'admin/invoices/pay',
        invoicePayAdminAPISchema,
      ),
      adminExportInvoice: createPath(
        MainRoutes.payment,
        'GET',
        'admin/invoices/export',
        invoiceExportAdminAPISchema,
      ),
      adminUploadInvoiceProof: createPath(
        MainRoutes.payment,
        'POST',
        'admin/invoice-proof',
        invoiceUploadProofAdminAPISchema,
      ),
      adminReviewInvoiceProof: createPath(
        MainRoutes.payment,
        'PATCH',
        'admin/invoice-proof/review',
        invoiceProofReviewAdminAPISchema,
      ),
      adminCloseInvoice: createPath(
        MainRoutes.payment,
        'POST',
        'admin/invoices/close',
        invoiceCloseAdminAPISchema,
      ),
      adminCaptureLegs: createPath(
        MainRoutes.payment,
        'POST',
        'admin/invoices/captureLegs',
        invoiceCaptureLegsAdminAPISchema,
      ),
      adminEligibleLegs: createPath(
        MainRoutes.payment,
        'GET',
        'admin/invoices/eligibleLegs',
        invoiceEligibleLegsAdminAPISchema,
      ),
      adminGetAllWallets: createPath(
        MainRoutes.payment,
        'GET',
        'admin/wallets-all',
        walletGetAllAdminAPISchema,
      ),
      adminGetOneWallet: createPath(
        MainRoutes.payment,
        'GET',
        'admin/wallet',
        walletGetOneAdminAPISchema,
      ),
      adminVerifyPendingTransaction: createPath(
        MainRoutes.payment,
        'PATCH',
        'admin/transactions/verify-pending',
        verifyPendingTransactionAPISchema,
      ),
      adminGetAllAccounts: createPath(
        MainRoutes.payment,
        'GET',
        'admin/accounts',
        accountGetAllAdminAPISchema,
      ),
      adminGetOneAccount: createPath(
        MainRoutes.payment,
        'GET',
        'admin/account',
        accountGetOneAdminAPISchema,
      ),
      adminGetAllAccountTransactions: createPath(
        MainRoutes.payment,
        'GET',
        'admin/account-transactions',
        accountTransactionGetAllAdminAPISchema,
      ),
    },
  },
  cashback: {
    mainPath: MainRoutes.cashback,
    paths: {
      getCurrentUser: createPath(MainRoutes.cashback, 'GET', 'current-user'),
    },
  },
  analytics: {
    mainPath: MainRoutes.analytics,
    paths: {
      //* customer
      /** @deprecated Use `myAnalyticsOverview` with `lens: 'as_customer'`. */
      customerAnalyticsOverview: createPath(MainRoutes.analytics, 'GET', 'customer-overview'),

      //* carrier
      /** @deprecated Use `myAnalyticsOverview` with `lens: 'as_carrier'`. */
      carrierAnalyticsOverview: createPath(MainRoutes.analytics, 'GET', 'carrier-overview'),

      //* my overview — role-neutral, lens-aware
      myAnalyticsOverview: createPath(
        MainRoutes.analytics,
        'GET',
        'my-overview',
        myAnalyticsOverviewSchema,
      ),

      //* app summary
      appSummary: createPath(
        MainRoutes.analytics,
        'GET',
        'app-summary',
        analyticsAppSummaryAPISchema,
      ),

      //* leads — super-admin CRM funnel rollup
      getLeads: createPath(MainRoutes.analytics, 'GET', 'leads', analyticsLeadsAPISchema),

      //* users — super-admin network Users rollup (mirrors leads shape)
      getUsers: createPath(MainRoutes.analytics, 'GET', 'users', analyticsUsersAPISchema),
    },
  },
  savedLocations: {
    mainPath: MainRoutes.savedLocations,
    paths: {
      getOne: createPath(MainRoutes.savedLocations, 'GET', '', savedLocationGetOneSchemaAPI),
      getAll: createPath(MainRoutes.savedLocations, 'GET', 'all', savedLocationGetAllSchemaAPI),
      search: createPath(MainRoutes.savedLocations, 'GET', 'search', savedLocationSearchSchemaAPI),
      createOne: createPath(MainRoutes.savedLocations, 'POST', '', savedLocationCreateAPISchema),
      updateOne: createPath(MainRoutes.savedLocations, 'PATCH', '', savedLocationUpdateAPISchema),
      deleteOne: createPath(MainRoutes.savedLocations, 'DELETE', '', savedLocationDeleteAPISchema),
      resolveGoogleUrl: createPath(
        MainRoutes.savedLocations,
        'POST',
        'resolve-google-url',
        savedLocationResolveGoogleUrlSchemaAPI,
      ),

      // admin apis
      adminGetAll: createPath(MainRoutes.savedLocations, 'GET', 'admin-all'),
      adminCreateOne: createPath(MainRoutes.savedLocations, 'POST', 'admin'),
    },
  },
  contacts: {
    mainPath: MainRoutes.contacts,
    paths: {
      getOne: createPath(MainRoutes.contacts, 'GET', '', contactGetOneSchemaAPI),
      getAll: createPath(MainRoutes.contacts, 'GET', 'all', contactGetAllSchemaAPI),
      adminGetAll: createPath(MainRoutes.contacts, 'GET', 'admin-all', contactGetAllAdminAPISchema),
      createOne: createPath(MainRoutes.contacts, 'POST', '', contactCreateAPISchema),
      updateOne: createPath(MainRoutes.contacts, 'PATCH', '', contactUpdateAPISchema),
      deleteOne: createPath(MainRoutes.contacts, 'DELETE', '', contactDeleteAPISchema),

      // admin apis
      adminCreateOne: createPath(MainRoutes.contacts, 'POST', 'admin', contactCreateAdminAPISchema),
    },
  },
  leads: {
    mainPath: MainRoutes.lead,
    paths: {
      // Public landing-form intake (no auth, rate-limited).
      publicCreate: createPath(MainRoutes.lead, 'POST', 'public', leadPublicCreateAPISchema),

      // Admin CRUD.
      adminGetAll: createPath(MainRoutes.lead, 'GET', 'admin-all', leadGetAllAdminAPISchema),
      getOne: createPath(MainRoutes.lead, 'GET', '', leadGetOneAPISchema),
      adminCreateOne: createPath(MainRoutes.lead, 'POST', 'admin', leadCreateAdminAPISchema),
      updateOne: createPath(MainRoutes.lead, 'PATCH', '', leadUpdateAPISchema),
      deleteOne: createPath(MainRoutes.lead, 'DELETE', '', leadDeleteAPISchema),

      // People sub-edits.
      addPerson: createPath(MainRoutes.lead, 'POST', 'person', leadAddPersonAPISchema),
      updatePerson: createPath(MainRoutes.lead, 'PATCH', 'person', leadUpdatePersonAPISchema),
      removePerson: createPath(MainRoutes.lead, 'DELETE', 'person', leadRemovePersonAPISchema),

      // Actions.
      addAction: createPath(MainRoutes.lead, 'POST', 'action', leadAddActionAPISchema),
      updateAction: createPath(MainRoutes.lead, 'PATCH', 'action', leadUpdateActionAPISchema),

      // Assignment + manual conversion link.
      assign: createPath(MainRoutes.lead, 'POST', 'assign', leadAssignAPISchema),
      convertLink: createPath(MainRoutes.lead, 'POST', 'convert-link', leadConvertLinkAPISchema),
    },
  },
  tickets: {
    mainPath: MainRoutes.ticket,
    paths: {
      adminGetAll: createPath(MainRoutes.ticket, 'GET', 'admin-all', ticketGetAllAdminAPISchema),
      counts: createPath(MainRoutes.ticket, 'GET', 'counts', ticketCountsAPISchema),
      getOne: createPath(MainRoutes.ticket, 'GET', '', ticketGetOneAPISchema),
      createOne: createPath(MainRoutes.ticket, 'POST', '', ticketCreateAPISchema),
      updateOne: createPath(MainRoutes.ticket, 'PATCH', '', ticketUpdateAPISchema),
      assign: createPath(MainRoutes.ticket, 'POST', 'assign', ticketAssignAPISchema),
      addNote: createPath(MainRoutes.ticket, 'POST', 'note', ticketAddNoteAPISchema),
      deleteOne: createPath(MainRoutes.ticket, 'DELETE', '', ticketDeleteAPISchema),
    },
  },
  clients: {
    mainPath: MainRoutes.clients,
    paths: {
      getOne: createPath(MainRoutes.clients, 'GET', '', clientGetOneSchemaAPI),
      getAll: createPath(MainRoutes.clients, 'GET', 'all', clientGetAllSchemaAPI),
      adminGetAll: createPath(MainRoutes.clients, 'GET', 'admin-all', clientGetAllAdminAPISchema),
      createOne: createPath(MainRoutes.clients, 'POST', '', clientCreateAPISchema),
      adminCreateOne: createPath(MainRoutes.clients, 'POST', 'admin', clientCreateAdminAPISchema),
      updateOne: createPath(MainRoutes.clients, 'PATCH', '', clientUpdateAPISchema),
      deleteOne: createPath(MainRoutes.clients, 'DELETE', '', clientDeleteAPISchema),
      lookupByLink: createPath(
        MainRoutes.clients,
        'GET',
        'lookup-by-link',
        clientLookupByLinkAPISchema,
      ),
    },
  },
  connection: {
    mainPath: MainRoutes.connection,
    paths: {
      getAll: createPath(MainRoutes.connection, 'GET', 'all', connectionGetAllAPISchema),
      getOne: createPath(MainRoutes.connection, 'GET', '', connectionGetOneAPISchema),
      accept: createPath(MainRoutes.connection, 'POST', 'accept', connectionAcceptAPISchema),
      block: createPath(MainRoutes.connection, 'POST', 'block', connectionBlockAPISchema),
    },
  },
  profile: {
    mainPath: MainRoutes.profile,
    paths: {
      getAll: createPath(MainRoutes.profile, 'GET', 'all', profileGetAllAPISchema),
      getOne: createPath(MainRoutes.profile, 'GET', '', profileGetOneAPISchema),
      createOne: createPath(MainRoutes.profile, 'POST', '', profileCreateAdminAPISchema),
      updateOne: createPath(MainRoutes.profile, 'PATCH', '', profileUpdateAdminAPISchema),
      deleteOne: createPath(MainRoutes.profile, 'DELETE', '', profileDeleteAdminAPISchema),
      bulkImport: createPath(
        MainRoutes.profile,
        'POST',
        'bulk-import',
        profileBulkImportAdminAPISchema,
      ),
      suggest: createPath(MainRoutes.profile, 'POST', 'suggest', profileSuggestAPISchema),
    },
  },
  /** Super-admin: reshape an account after signup. See `account-ops.api.ts`. */
  accountOps: {
    mainPath: MainRoutes.accountOps,
    paths: {
      preview: createPath(MainRoutes.accountOps, 'POST', 'preview', accountOpsRequestSchema),
      execute: createPath(MainRoutes.accountOps, 'POST', 'execute', accountOpsRequestSchema),
    },
  },
  org: {
    mainPath: MainRoutes.org,
    paths: {
      getAll: createPath(MainRoutes.org, 'GET', 'all', orgGetAllAPISchema),
      getOne: createPath(MainRoutes.org, 'GET', '', orgGetOneAPISchema),
      updateOne: createPath(MainRoutes.org, 'PATCH', '', orgUpdateAPISchema),
    },
  },
  /**
   * `org/profile` — section-keyed, field-level partial profile updates.
   * Replaces the legacy `organization/profile` surface; see
   * `orgProfileUpdateSchema` for the body contract and
   * `OrgProfileService` for the "no `overwriteAnyNestedField` ever"
   * write semantics.
   */
  orgProfile: {
    mainPath: MainRoutes.orgProfile,
    paths: {
      get: createPath(MainRoutes.orgProfile, 'GET', '', orgProfileGetAPISchema),
      update: createPath(MainRoutes.orgProfile, 'PATCH', '', orgProfileUpdateAPISchema),
      adminGet: createPath(MainRoutes.orgProfile, 'GET', 'admin', orgProfileAdminGetAPISchema),
      adminUpdate: createPath(
        MainRoutes.orgProfile,
        'PATCH',
        'admin',
        orgProfileAdminUpdateAPISchema,
      ),
    },
  },
  entityDirectory: {
    mainPath: MainRoutes.entityDirectory,
    paths: {
      search: createPath(
        MainRoutes.entityDirectory,
        'GET',
        'search',
        entityDirectorySearchAPISchema,
      ),
    },
  },
  version: {
    mainPath: MainRoutes.version,
    paths: {
      checkVersion: createPath(MainRoutes.version, 'GET', 'check', versionCheckAPISchema),
    },
  },
  devTools: {
    mainPath: MainRoutes.devTools,
    paths: {
      reset: createPath(MainRoutes.devTools, 'DELETE', 'reset', devResetAPISchema),
    },
  },
  featureFlags: {
    mainPath: MainRoutes.featureFlags,
    paths: {
      getAll: createPath(MainRoutes.featureFlags, 'GET', 'all'),
    },
  },
  apps: {
    mainPath: MainRoutes.apps,
    paths: {
      getAll: createPath(MainRoutes.apps, 'GET', 'all'),
      applyEarlyAccess: createPath(
        MainRoutes.apps,
        'POST',
        'apply-early-access',
        appApplyEarlyAccessAPISchema,
      ),
      // --- Installs ---
      // All Org-scoped: the Org comes from the auth token, never the body.
      getInstalled: createPath(MainRoutes.apps, 'GET', 'installed'),
      // --- Logisti / Bayan connector ---
      logistiInstall: createPath(
        MainRoutes.apps,
        'POST',
        'logisti/install',
        appLogistiInstallAPISchema,
      ),
      logistiUninstall: createPath(MainRoutes.apps, 'DELETE', 'logisti/install'),
      logistiUpdateSettings: createPath(
        MainRoutes.apps,
        'PATCH',
        'logisti/settings',
        logistiSettingsAPISchema,
      ),
      logistiGoodTypes: createPath(MainRoutes.apps, 'GET', 'logisti/good-types'),
      logistiIssueWaybill: createPath(
        MainRoutes.apps,
        'POST',
        'logisti/waybill/issue',
        appIssueWaybillBayanAPISchema,
      ),
      logistiWaybillStatus: createPath(
        MainRoutes.apps,
        'GET',
        'logisti/waybill/status',
        orderWaybillBayanAPISchema,
      ),
      logistiWaybillPdf: createPath(
        MainRoutes.apps,
        'GET',
        'logisti/waybill/pdf',
        orderWaybillBayanAPISchema,
      ),
    },
  },
  zapier: {
    mainPath: MainRoutes.zapier,
    paths: {
      // invoice
      invoiceClosingCronJob: createPath(MainRoutes.zapier, 'GET', 'invoice/closing-cron-job'),

      // analytics
      analyticsReport: createPath(MainRoutes.zapier, 'GET', 'analytics/report'),

      // cashback
      cashbackCronJob: createPath(MainRoutes.zapier, 'GET', 'cashback/update'),

      // sales — subscription renewal cron
      subscriptionRenewalCronJob: createPath(MainRoutes.zapier, 'GET', 'subscription/renew-due'),
      billingTransactionSyncCronJob: createPath(
        MainRoutes.zapier,
        'GET',
        'billing-transaction/sync-pending',
      ),

      // agent — driver-comms AgentTask worker (dispatch queued + sweep timeouts)
      agentTaskWorkerCronJob: createPath(MainRoutes.zapier, 'GET', 'agent-task/run-worker'),

      // apps — re-attempt provider calls that failed transiently (Bayan /
      // Logisti). Every 10 minutes is enough: the inline retries in
      // `BayanClient` already absorb single dropped connections, so this
      // sweep only exists for outages measured in minutes.
      appRetryCronJob: createPath(MainRoutes.zapier, 'GET', 'apps/retry-sweep'),

      // orders — close open orders idle ≥ 5 days (no doc.updatedAt bump)
      orderAutoCloseCronJob: createPath(MainRoutes.zapier, 'GET', 'order/auto-close'),

      // agent — WhatsApp outbound queue recovery: retry rows whose backoff
      // elapsed, force-fail poison rows, and post the CLOSE a dead replica
      // never got to. Every minute: the normal path is the in-process
      // drain, so this only has to bound how long a *failure* lasts.
      // See docs/ai/messaging-model.md § The sweeper.
      whatsappOutboundSweepCronJob: createPath(
        MainRoutes.zapier,
        'GET',
        'agent/whatsapp-outbound-sweep',
      ),
    },
  },
  subscription: {
    mainPath: MainRoutes.subscription,
    paths: {
      getMine: createPath(MainRoutes.subscription, 'GET', 'me', subscriptionGetMineAPISchema),
      getUsage: createPath(MainRoutes.subscription, 'GET', 'usage', subscriptionGetUsageAPISchema),
      adminGet: createPath(MainRoutes.subscription, 'GET', 'admin', subscriptionGetAdminAPISchema),
      adminGetAll: createPath(
        MainRoutes.subscription,
        'GET',
        'admin/all',
        subscriptionAdminGetAllAPISchema,
      ),
      subscribe: createPath(MainRoutes.subscription, 'POST', '', subscriptionSubscribeAPISchema),
      pay: createPath(MainRoutes.subscription, 'POST', 'pay', subscriptionPayAPISchema),
      changePlan: createPath(
        MainRoutes.subscription,
        'PATCH',
        'plan',
        subscriptionChangePlanAPISchema,
      ),
      changeInterval: createPath(
        MainRoutes.subscription,
        'PATCH',
        'interval',
        subscriptionChangeIntervalAPISchema,
      ),
      changeSeats: createPath(
        MainRoutes.subscription,
        'PATCH',
        'seats',
        subscriptionChangeSeatsAPISchema,
      ),
      addAddon: createPath(MainRoutes.subscription, 'POST', 'addon', subscriptionAddAddonAPISchema),
      removeAddon: createPath(
        MainRoutes.subscription,
        'DELETE',
        'addon',
        subscriptionRemoveAddonAPISchema,
      ),
      cancel: createPath(MainRoutes.subscription, 'POST', 'cancel', subscriptionCancelAPISchema),
      adminOverride: createPath(
        MainRoutes.subscription,
        'PATCH',
        'admin/override',
        subscriptionAdminOverrideAPISchema,
      ),
      adminForceRenew: createPath(
        MainRoutes.subscription,
        'POST',
        'admin/renew',
        subscriptionAdminForceRenewAPISchema,
      ),
      adminGrantCredits: createPath(
        MainRoutes.subscription,
        'POST',
        'admin/grant-credits',
        subscriptionAdminGrantCreditsAPISchema,
      ),
      adminRevokeCredits: createPath(
        MainRoutes.subscription,
        'POST',
        'admin/revoke-credits',
        subscriptionAdminRevokeCreditsAPISchema,
      ),
      adminResetFreeCredits: createPath(
        MainRoutes.subscription,
        'POST',
        'admin/reset-free-credits',
        subscriptionAdminResetFreeCreditsAPISchema,
      ),
      paymentMethodCheckout: createPath(
        MainRoutes.subscription,
        'POST',
        'payment-method/checkout',
        subscriptionPaymentMethodCheckoutAPISchema,
      ),
      paymentMethodDelete: createPath(
        MainRoutes.subscription,
        'DELETE',
        'payment-method',
        subscriptionPaymentMethodDeleteAPISchema,
      ),
    },
  },
  billing: {
    mainPath: MainRoutes.billing,
    paths: {
      getOne: createPath(MainRoutes.billing, 'GET', '', billingGetOneAPISchema),
      getMany: createPath(MainRoutes.billing, 'GET', 'many', billingGetManyAPISchema),
      adminGetAll: createPath(MainRoutes.billing, 'GET', 'admin/all', billingAdminGetAllAPISchema),
      adminCancel: createPath(
        MainRoutes.billing,
        'POST',
        'admin/cancel',
        billingAdminCancelAPISchema,
      ),
    },
  },
  billingTransaction: {
    mainPath: MainRoutes.billingTransaction,
    paths: {
      getOne: createPath(
        MainRoutes.billingTransaction,
        'GET',
        '',
        billingTransactionGetOneAPISchema,
      ),
      getMany: createPath(
        MainRoutes.billingTransaction,
        'GET',
        'many',
        billingTransactionGetManyAPISchema,
      ),
      adminRefund: createPath(
        MainRoutes.billingTransaction,
        'POST',
        'admin/refund',
        billingTransactionAdminRefundAPISchema,
      ),
      byGatewayPaymentId: createPath(
        MainRoutes.billingTransaction,
        'GET',
        'by-gateway-payment-id',
        billingTransactionByGatewayPaymentIdAPISchema,
      ),
    },
  },
  features: {
    mainPath: MainRoutes.features,
    paths: {
      getMine: createPath(MainRoutes.features, 'GET', 'me', featuresGetMineAPISchema),
      adminGet: createPath(MainRoutes.features, 'GET', 'admin', featuresGetAdminAPISchema),
    },
  },
  moyasar: {
    mainPath: MainRoutes.moyasar,
    paths: {
      webhook: createPath(MainRoutes.moyasar, 'POST', 'webhook', moyasarWebhookAPISchema),
    },
  },
} as const;

/**
 * Type that creates a union of string literals for all API paths.
 * Format: "parent.path" (e.g., "vehicle.getOne", "order.getWaybill")
 * Usage: HeroAPIs gives you "vehicle.getOne" | "vehicle.getMyVehicle" | "order.getOne" | ...
 */
export type HeroAPIs = {
  [K in keyof typeof API_ENDPOINTS]: {
    [P in keyof (typeof API_ENDPOINTS)[K]['paths']]: `${string & K}.${string & P}`;
  }[keyof (typeof API_ENDPOINTS)[K]['paths']];
}[keyof typeof API_ENDPOINTS];

/**
 * Helper type to extract the APIRoute from a HeroAPIs string path
 */
export type GetAPIRoute<T extends HeroAPIs> = T extends `${infer K}.${infer P}`
  ? K extends keyof typeof API_ENDPOINTS
    ? P extends keyof (typeof API_ENDPOINTS)[K]['paths']
      ? (typeof API_ENDPOINTS)[K]['paths'][P]
      : never
    : never
  : never;

/**
 * Helper function to get the APIRoute from a HeroAPIs string path
 * @param apiName - A string in the format "parent.path" (e.g., "vehicle.getOne")
 * @returns The APIRoute object for that endpoint
 */
export function getAPIEndpoint<T extends HeroAPIs>(apiName: T): GetAPIRoute<T> {
  const parts = apiName.split('.') as [string, string];
  const parent = parts[0] as keyof typeof API_ENDPOINTS;
  const path = parts[1] as string;
  const parentObj = API_ENDPOINTS[parent];
  return (parentObj.paths as Record<string, APIRoute>)[path] as GetAPIRoute<T>;
}
